import styled from 'styled-components';


export const InputElementWrapper = styled.div`
width: 100%;
box-sizing: border-box;
margin-bottom: 30px;
`;
